import { IconBan, IconCheck, IconCopy, IconExternalLink, IconMessage, IconSettings, IconTrash } from '../../componentes/Icons';
import './GradeUnidades.css';

const GradeUnidades = ({
    tenants,
    SUBSCRIPTION_PLANS,
    userCounts,
    tenantUsers,
    handleCopyLink,
    handleContactOwner,
    handleStartEdit,
    toggleStatus,
    handleDeleteTenant,
    setViewingUsers
}) => {
    return (
        <section className="grade-unidades">
            {tenants.map(tenant => (
                <div key={tenant.id} className={`tenant-card ${tenant.status}`}>
                    <div className="tenant-card-header">
                        <div className="tenant-main-info">
                            <h4>{tenant.name}</h4>
                            <span className="tenant-id-badge">ID: {tenant.id}</span>
                        </div>
                        <span className={`tenant-status-pill ${tenant.status}`}>
                            {tenant.status === 'active' ? 'Ativo' : 'Inativo'}
                        </span>
                    </div>

                    <div className="tenant-details">
                        <div className="detail-item">
                            <span className="detail-label">Plano</span>
                            <span style={{ fontWeight: 800, color: 'var(--gold-primary)' }}>
                                {SUBSCRIPTION_PLANS[tenant.plan || 'ouro']?.name || 'Ouro'}
                            </span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Contato</span>
                            <span>{tenant.ownerPhone || 'Não cadastrado'}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Gerentes</span>
                            <span>{tenant.adminEmails?.length || 0} Administradores</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Vencimento</span>
                            <span style={{
                                color: tenant.dueDate && new Date(tenant.dueDate) < new Date() ? 'var(--accent-red)' : 'inherit',
                                fontWeight: tenant.dueDate && new Date(tenant.dueDate) < new Date() ? 'bold' : 'normal'
                            }}>
                                {tenant.dueDate ? new Date(tenant.dueDate).toLocaleDateString('pt-BR') : 'Sem data'}
                                {tenant.dueDate && (
                                    <span style={{ fontSize: '0.8rem', opacity: 0.6, marginLeft: '8px' }}>
                                        ({Math.ceil((new Date(tenant.dueDate) - new Date()) / (1000 * 60 * 60 * 24))} dias)
                                    </span>
                                )}
                            </span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Usuários</span>
                            <div className="user-count-section">
                                <span>{userCounts[tenant.id] || 0} ativos</span>
                                {userCounts[tenant.id] > 0 && (
                                    <button
                                        className="view-users-btn"
                                        onClick={() => setViewingUsers({
                                            tenantId: tenant.id,
                                            tenantName: tenant.name,
                                            users: tenantUsers[tenant.id]
                                        })}
                                    >
                                        Ver Lista
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="tenant-actions">
                        <button className="action-btn" title="Copiar Link" onClick={() => handleCopyLink(tenant.id)}><IconCopy /></button>
                        <button className="action-btn" title="Acessar Loja" onClick={() => window.open(`${window.location.origin}/?shop=${tenant.id}`, '_blank')}><IconExternalLink /></button>
                        <button className="action-btn whatsapp" title="WhatsApp" onClick={() => handleContactOwner(tenant.ownerPhone)}><IconMessage /></button>
                        <button className="action-btn" title="Configurar" onClick={() => handleStartEdit(tenant)}><IconSettings /></button>
                        <button className="action-btn" title={tenant.status === 'active' ? 'Suspender' : 'Reativar'} onClick={() => toggleStatus(tenant)}>
                            {tenant.status === 'active' ? <IconBan /> : <IconCheck />}
                        </button>
                        <button className="action-btn delete" title="Remover" onClick={() => handleDeleteTenant(tenant.id, tenant.name)}><IconTrash /></button>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default GradeUnidades;
